import { FundraiserSearchFilter } from 'src/modules/fundraiser/models/fundraiserSearchFilter';
import { FundraiserResponse } from 'src/modules/fundraiser/models/fundraiserResponse';
import { FundraiserPaymentDistributionResponse } from 'src/modules/fundraiser/models/fundraiserPaymentDistributionResponse';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'Fundraiser';

export const getAllFundraiser = (searchFilter: FundraiserSearchFilter) => {
  return AxiosInstance.get<PagedResult<FundraiserResponse>>(controller, { params: searchFilter });
};

export const getFundraiserById = (id: string | undefined) => {
  return AxiosInstance.get<FundraiserResponse>(`${controller}/${id}`);
};

export const getFundraiserPaymentDistribution = (fundraiserId: number, startDate?: string, endDate?: string) => {
  return AxiosInstance.get<FundraiserPaymentDistributionResponse>(`${controller}/PaymentDistribution`, {
    params: {
      fundraiserId,
      startDate,
      endDate,
    },
  });
};
